(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('cloudApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('BUILD_TIMESTAMP', 1723055478385)
        .constant('APP_VERSION', "2.0.0")
        .constant('SERVER_API_URL', "http://3.231.27.25:8080/cloud/")
;
})();
